<template>
  <article
    v-if="channel"
    class="list-item__card list-item__card--expanded"
    :data-placeholder="placeholder"
    :highlight="showHighlight"
    @click="goToPillars"
  >
    <div class="expanded-card__member">
      <CChannelHighlight
        v-if="channel.staffArray.length"
        tooltip-position="top-start"
        size="small"
        :channel-id="channel.id"
        :is-highlighted="channel.highlight"
      />

      <WParagraph class="list-item__member expanded-card__member-name">
        {{ member && member.fullName }}
      </WParagraph>
    </div>

    <div v-if="!showAssessment" class="expanded-card__channel">
      <WParagraph
        v-if="channel.name"
        class="list-item__extra-info"
        :title="channel.name"
      >
        {{ channel.name }}
      </WParagraph>

      <WParagraph v-else class="list-item__extra-info list-item__tag">
        {{ chatLabel }}
      </WParagraph>
    </div>

    <div class="expanded-card__message" :data-large="shouldShowAssessment">
      <CAssessmentIcon
        v-if="showAssessment"
        :assessment="assessment"
        icon-only
      />
      <CPreviewableMessage
        :staffs="channel.staffs"
        :previewable-messages="channel.previewableMessages"
        :last-previewable-message="channel.lastPreviewableMessage"
        :multiple-lines="!channel.name"
        hide-member-name
      />

      <CChannelTag
        v-if="isChannelArchived"
        class="list-item__left-info"
        :tag="archivedChannelTag"
      />

      <div v-else class="expanded-card__container-tag">
        <PMemberTypeTag
          v-for="tag in member.tags"
          :key="tag.type"
          class="list-item__left-info"
          :tag="tag"
        />

        <CChannelTag
          v-if="isFirstAccessAndScreeningNurse"
          class="list-item__left-info"
          :tag="firstAccessChannelTag"
        />
      </div>
    </div>

    <div class="expanded-card__staff">
      <CHealthcareTeam
        v-if="showStaff"
        limit
        layout="names"
        :team="channelStaffTeam"
      />
      <WLabel v-if="showWaitingForN2" mode="warning"> Aguardando N2 </WLabel>
    </div>

    <div class="list-item__info expanded-card__info">
      <CNotificationsGroup
        :is-tab="false"
        :counters="staffNotifications"
        show-mentions
      />
      <WHelper v-if="dateField" class="list-item__time-message">
        {{ dateField }}
      </WHelper>
      <CChannelSla
        v-if="showSla"
        class="list-item__sla"
        :channel="channel"
        tooltip-position="top-end"
      />
    </div>
  </article>
</template>

<script>
import { WHelper, WLabel, WParagraph } from '@alice-health/wonderland-vue'

import { PMemberTypeTag } from '@/components/pillars/atoms'

import { CChannelTag } from '../../atoms'
import PSidenavListItemCompact from './PSidenavListItemCompact'

export default {
  components: {
    CChannelTag,
    PMemberTypeTag,
    WParagraph,
    WHelper,
    WLabel
  },
  extends: PSidenavListItemCompact,
  computed: {
    shouldShowAssessment() {
      return this.showAssessment ? this.showAssessment : null
    }
  }
}
</script>

<style lang="scss">
.list-item__card.list-item__card--expanded {
  align-items: flex-start;
  display: grid;
  gap: var(--gl-spacing-04);
  grid-template-columns: repeat(12, minmax(0, 1fr));

  & + & {
    margin-top: 12px;
  }
}

.expanded-card {
  &__member {
    align-items: center;
    display: flex;
    gap: var(--gl-spacing-02);
    grid-column: 3 span;
  }

  &__channel {
    align-items: center;
    display: flex;
    grid-column: 2 span;

    .list-item__extra-info {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &__message {
    grid-column: 3 span;

    &[data-large] {
      align-items: center;
      display: flex;
      gap: var(--gl-spacing-04);
      grid-column: 5 span;
    }
  }

  &__staff {
    display: flex;
    grid-column: 2 span;
  }

  &__info {
    display: flex;
    grid-column: 2 span;
    min-height: 24px;
    white-space: nowrap;
  }

  &__container-tag {
    display: flex;

    .list-item__left-info {
      margin-left: var(--gl-spacing-02);
    }

    .list-item__left-info:first-child {
      margin-left: 0;
    }

    .list-item__left-info.h-tag {
      padding: 0 var(--gl-spacing-02);
    }
  }
}
</style>
